export default {
  device: {
    tabTitle: 'Device List',
    colDeviceType: 'Device Type',
    colDeviceName: 'Device Name',
    colModel: 'Model',
    colSerial: 'Serial number',
    colIP: 'IP address',
    colVersion: 'Version',
    colMAC: 'MAC address',
    colActiveDate: 'Active Date',
    btnRemoteInfo: 'Remote Info',
    typeTablet: 'Tablet Client',
    typePhone: 'Phone Client',
    typeKDS: 'KDS Client',
    typeQS: 'QS Client',
    typePOS: 'POS Sale Client',
    typeKiosk: 'Kiosk Client',
    typeHandheld: 'Handheld Client',
    typeServer: 'POS Sale Server',
    typePhPhone: 'Phone',
    typePhTablet: 'Tablet',
    typePhPC: 'PC/POS',
    typePhServer: 'Server',
    typePhBackEnd: 'BackEnd',
    typePhKDS: 'Tablet (KDS)',
    typeComPCPOS: 'PC/POS',
    typeComKDS: 'KDS',
    typeComAndroid: 'Android',
    typeComIOS: 'iOS',
    typeComClient: 'Client',
  },
  remote: {
    title: 'Remote Info',
    colPlatform: 'Platform',
    colRemoteId: 'Remote ID',
    colAccessCode: 'Access Code',
    btnAddRow: 'Add Row',
    btnCancel: 'Cancel',
    btnSave: 'Save',
    platformRustdesk: 'Rustdesk',
    platformMacDeskID: 'MacDesk ID',
    platformTeamviewer: 'Teamviewer',
    platformUltraview: 'Ultraview',
    platformAnydesk: 'Anydesk',
  },
};
